import styled from '@emotion/styled';
import {
  ButtonNormalPrimaryMediumCompact,
  TextDisplayAlt,
  TextParagraph,
  token,
} from '@angeplus/prever-component-lib';
import { LinkWrapper } from '@angeplus/prever-component-lib/nextjs';

import { CONTRACT } from '../../../routes';
import { PlansCarousel } from './PlansCarousel';
import { PlansList } from './PlansList';

export const PlansSection = () => (
  <PlansSectionContainer id="planos">
    <PlansContent>
      <PlansHeader>
        <PlansTitle>Seu plano digital na palma da sua mão</PlansTitle>
        <PlansSubtitle>
          Seu plano sempre acessível para você consultar qualquer momento e
          lugar.
        </PlansSubtitle>
        <LinkWrapper href={CONTRACT}>
          <ButtonNormalPrimaryMediumCompact>
            Ir para Meu Plano
          </ButtonNormalPrimaryMediumCompact>
        </LinkWrapper>
      </PlansHeader>
      <PlansList />
    </PlansContent>

    <CarouselContainer>
      <PlansCarousel />
    </CarouselContainer>
  </PlansSectionContainer>
);

const PlansSectionContainer = styled.section`
  background-color: ${token.colors.solidAngeplusForeground};
  padding: ${token.spacing.spacingXxLarge} 0;
  width: 100%;
`;

const PlansContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 ${token.spacing.spacingMedium};
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const PlansHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: ${token.spacing.spacingLarge};
  margin-bottom: ${token.spacing.spacingXLarge};
  max-width: 800px;
`;

const PlansTitle = styled(TextDisplayAlt)`
  color: white !important;
  font-size: 32px;

  @media (min-width: 768px) {
    font-size: 40px;
  }
`;

const PlansSubtitle = styled(TextParagraph)`
  color: white !important;
  font-size: 16px;

  @media (min-width: 768px) {
    font-size: 18px;
  }
`;

const CarouselContainer = styled.div`
  width: 100vw;
`;
